import vuetify from '@/plugins/vuetify'

const STORAGE_KEY = 'tapapp-theme'

function themeFromCookie () {
  const match = document.cookie.match(/(?:^|; )tapapp-theme=(dark|light)/)
  return match ? match[1] : null
}

export function currentTheme () {
  const fromCookie = themeFromCookie()
  if (fromCookie) return fromCookie
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
  } catch (err) {
    return 'light'
  }
}

export function applyTheme (theme) {
  const next = theme === 'dark' ? 'dark' : 'light'
  if (next === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark')
  } else {
    document.documentElement.removeAttribute('data-theme')
  }
  try {
    localStorage.setItem(STORAGE_KEY, next)
  } catch (err) {}
  if (vuetify?.theme?.global?.name) {
    vuetify.theme.global.name.value = next
  }
  document.dispatchEvent(new CustomEvent('tapapp-theme-change', { detail: next }))
  return next
}
